
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper'; 
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        components: {
            XBreadcrumb,
            WhatsApp,
        },
        data() {
            return {
                group: [],
                groupSelected: {
                    name: ""
                },
                modulesPlan: [],
                premioMensual: null,
                coberturas: [],
                Plandata: [],
                selectedPlan: null,
                finallyCalculationResult: [],
                plans: [],  // Cambiado de null a una lista vacía
                col: 2,
                plansLength: 0,  // Cambiado de null a 0
                notCover: null,
                reload: true,
                additionalBenefits: [],
                dataTabHome: null,
                peopleToCover: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/salud-segura-max' },
                    { text: 'Elegí un Plan', path: '/salud-segura-max/plan' },
                ],
                leadId: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Salud Segura Max';
                const actualPath = '/salud-segura-max';
                const actualStep = 'quoted';

                const request = new SaveMultiQuoteNotificationsRequest();
                request.phone = this.dataTabHome.areaCode + this.dataTabHome.telephone;
                request.mail = this.dataTabHome.email;
                request.quotePlan = this.groupSelected.name;
                request.quotationDetail = "Producto: " + defaultTitle
                                + " - Localidad: " + this.dataTabHome.selectedLocality.text
                                + " - Personas: " + this.peopleToCover;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            removePTags(text) {
                // Remover etiquetas <p> del texto
                return text.replace(/<\/?p>/g, '');
            },
            extractCoverDescriptions() {
                const descriptions = this.additionalBenefits.map(item => item.coverDescription);
                const lastDescription = descriptions.pop(); // Extraer y guardar el último elemento
                if (descriptions.length === 0) {
                    return lastDescription; // Si solo hay un elemento, devolverlo sin separador
                } else {
                    return descriptions.join(', ') + ' y ' + lastDescription;
                }
            },
            loadAdditionalBenefits() {
                this.additionalBenefits = JSON.parse(sessionStorage.getItem("additionalBenefitsVWHealthGridCovers"));
            },
            selectedPlans: function (quotationData) {
                // se le envia el pricingId del plan que se haya elegido
                let pricingId = parseInt(quotationData.pricingId[0])
                quotationData.planDescription = this.groupSelected.name;
                sessionStorage.setItem("selectedPricingId", pricingId.toString());
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                sessionStorage.setItem("PlanDescription", JSON.stringify(quotationData.planDescription));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        this.$router.push({
                            name: 'healthMaxPolicyOwner-view',
                        })
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': JSON.parse(sessionStorage.getItem("DataTabHome")).email,
                            'product': 'salud', 'event': 'errorServidor',
                            'paso': 'cotizador-salud-plan',
                            'referente': this.referente
                        });
                    }
                }).catch(error => {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("DataTabHome")).email,
                        'product': 'salud', 'event': 'errorServidor',
                        'paso': 'cotizador-salud-plan',
                        'referente': this.referente
                    });
                });
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'healthMaxHome-view',
                })
            },
            openModalDataCoberturas: function (plan) {
                var grid = sessionStorage.getItem("responseGetVWHealthGridCovers");
                var gridJson = JSON.parse(grid);
                // Obtener la lista de VWGridCovers
                let VWGridCovers = gridJson.vwGridCovers;
                let group = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);//Se define el grupo por cantidad de personas
                let coversCapitalAndDescription = JSON.parse(sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (group)));
                // Filtrar los elementos que tengan gridCategoriesId igual a 1 y calcular el valor booleano
                const filteredItems = VWGridCovers.filter(item => item.gridCategoriesId === 1).map(item => {
                    return {
                        coverDescription: item.coverDescription.trim(),
                        isChecked: item.verticalGroupsId.includes(group),
                        capital: coversCapitalAndDescription.find(cover => cover.coverCode === item.coverNumber).capital
                    };
                });

                this.coberturas = filteredItems;
                this.$refs.modalDataCoberturas.open();
            },
            openModalAdditionalBenefits: function () {
                this.$refs.modalAdditionalBenefits.open();
            },
            closeModalDataCoberturas: function () {
                this.$refs.modalDataCoberturas.close();
            },
            closeModalAdditionalBenefits: function () {
                this.$refs.modalAdditionalBenefits.close();
            },
            dataPlans: function () {
                let planData = sessionStorage.getItem("responseHealth321Quotation");
                let planDataRequotationTemp = sessionStorage.getItem("responseHealth321Requotation");
                let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"), 10);
                let planDataFinal = peopleToCover === 1 ? planData : planDataRequotationTemp;
                let group = sessionStorage.getItem("responseGetVWHealthGridGroups");

                if (group) {
                    this.group = JSON.parse(group);
                } else {
                    console.error("Group data is not available in sessionStorage.");
                    return;
                }

                if (planDataFinal) {
                    let planDataJson = JSON.parse(planDataFinal);
                    if (planDataJson.hasOwnProperty('plans')) {
                        this.plansLength = planDataJson.plans.length;
                        let planDataOriginal = JSON.parse(planData).plans;
                        this.plans = planDataJson.plans;
                        for (let i = 0; i < this.plans.length; i++) {
                            if (peopleToCover > 1) {
                                this.plans[i].discounts = planDataOriginal[i].discounts;
                            }
                            let pp = this.plans[i].finallyCalculationResult.filter(o => o.detalleInt === 1)[0];
                            this.plans[i].finallyCalculationResult.filter(o => o.detalleInt === 1);
                            Object.assign(this.plans[i], this.modulesPlan[i]);
                            Object.assign(this.plans[i], pp);
                        }
                    } else {
                        console.error("La propiedad 'plans' no está definida en el objeto 'planDataJson'.");
                    }
                } else {
                    console.error("Plan data is not available in sessionStorage.");
                }
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true")

                NF.UI.Page.block();
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                this.dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                const additionalInformation = {
                    'Localidad': this.dataTabHome.selectedLocality.name,
                    'Personas a cubrir': this.dataTabHome.peopleToCover.toString()
                };
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.dataTabHome.email, location.href, this.dataTabHome.areaCode, this.dataTabHome.telephone, 321, false, "2", additionalInformation, null, null);
                this.peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"), 10);
                if (!isNaN(this.peopleToCover)) {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("DataTabHome")).email,
                        'product': 'salud',
                        'event': 'cotizador-salud-datos-personales',
                        'personas': (this.peopleToCover?.toString() ?? ''),
                        'referente': this.referente
                    });
                }
                this.groupSelected = this.group.find(item => item.id == (this.peopleToCover > 1 ? 3 : 1));
                if (this.groupSelected) {
                    sessionStorage.setItem("groupSelected", JSON.stringify(this.groupSelected));
                } else {
                    console.error("Group selected not found.");
                }
                this.loadAdditionalBenefits();
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                sessionStorage.removeItem("pressBack");
                NF.UI.Page.unblock();
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.dataPlans(),
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.getInitData();
                await this.pageCustomization();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
